const indexItems = [
  { title: '院线大片', desc: '最新上映热门影片', count: '326部', icon: 'ri-film-line', color: 'primary' as const },
  { title: '热播电视剧', desc: '追剧党不容错过', count: '518部', icon: 'ri-tv-line', color: 'accent' as const },
  { title: '综艺娱乐', desc: '轻松解压笑点不断', count: '243个', icon: 'ri-emotion-happy-line', color: 'primary' as const },
  { title: '动漫番剧', desc: '日漫国漫全收录', count: '892部', icon: 'ri-ghost-smile-line', color: 'accent' as const },
  { title: '经典老片', desc: '重温银幕经典', count: '456部', icon: 'ri-vip-crown-line', color: 'primary' as const },
  { title: '纪录片', desc: '探索真实世界', count: '187部', icon: 'ri-earth-line', color: 'accent' as const },
  { title: '悬疑推理', desc: '烧脑剧情高能反转', count: '274部', icon: 'ri-search-eye-line', color: 'primary' as const },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">影视专题</h2>
            <p className="mt-3 text-sm text-foreground-500">分类浏览 · 快速找到你想看的</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
            {indexItems.map((item) => {
              const isPrimary = item.color === 'primary';
              return (
                <div
                  key={item.title}
                  className={`group rounded-2xl p-5 md:p-6 cursor-pointer transition-all duration-300 hover:-translate-y-1 ${
                    isPrimary ? 'bg-background-100 hover:bg-primary-50/60' : 'bg-background-100 hover:bg-accent-50/60'
                  }`}
                >
                  <div className={`w-11 h-11 rounded-xl flex items-center justify-center mb-4 ${
                    isPrimary ? 'bg-primary-100 text-primary-600' : 'bg-accent-100 text-accent-600'
                  }`}>
                    <i className={`${item.icon} text-lg`}></i>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900">{item.title}</h3>
                  <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
                  <div className="mt-3 flex items-center justify-between">
                    <span className={`text-xs font-medium ${isPrimary ? 'text-primary-600' : 'text-accent-600'}`}>{item.count}</span>
                    <i className={`ri-arrow-right-line text-sm ${isPrimary ? 'text-primary-400' : 'text-accent-400'} opacity-0 group-hover:opacity-100 transition-opacity`}></i>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}